import React from "react";
import success from "../../Assets/Toaster/Check circle.svg";
import error from "../../Assets/Toaster/X circle.svg";
import warning from "../../Assets/Toaster/Exclamation.svg";

export const SuccessIcon = () => <img src={success} alt="Success" />;
export const ErrorIcon = () => <img src={error} alt="Error" />;
export const WarningIcon = () => <img src={warning} alt="Warning" />;
